module.exports = __webpack_public_path__ + "static/project-snake-f5c2c9f6af7f29951ecbfcd955d9296e.png";